module.exports = __webpack_public_path__ + "static/media/sell_start_service_teach_2.c43885fa.jpg";